import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getBroadcastsConfigState } from 'bdata-sns-shared/store/selectors/broadcastsConfigSelector';
import GameInfoLayer from '../components/GameInfoLayer/GameInfoLayer';
import getPartnerBroadcasterConfig from 'bdata-sns-shared/utils/getPartnerBroadcasterConfig';

const GameInfoContainer = ({
    epglist,
    epgContentList,
    isFreeGame,
    nationalBroadcaster
}) => {
    const { epg: epgConfig, useContentEpg } = useSelector(getBroadcastsConfigState) || {};
    const partnersGameList = useMemo(() => {
        return getPartnerBroadcasterConfig({ epglist, epgContentList, useContentEpg, epgConfig });
    }, [epglist, epgContentList, useContentEpg, epgConfig]);


    return <GameInfoLayer nationalBroadcaster={nationalBroadcaster} freeGameList={partnersGameList} isFreeGame={isFreeGame} />;
};

GameInfoContainer.propTypes = {
    epglist: PropTypes.array,
    isFreeGame: PropTypes.bool,
    nationalBroadcaster: PropTypes.string
};

export default GameInfoContainer;
